import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { CONFIGAPI } from '@/api/config'

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IIssuesState {
  handlerList: []; // 受理人
}

@Module({ dynamic: true, store, name: 'issues' })
class Issues extends VuexModule implements IIssuesState {
  public handlerList: [] = []

  public tutorHandler: [] = []

  @Mutation
  private SET_ISSUEHANDLER(appId: string) {
    // if (this.handlerList.length === 0) {
    CONFIGAPI.getHandlerList({ app_id: appId })
      .then(response => {
        this.handlerList = response.data.lists || []
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(() => {
      })
    // }
  }

  // 受理人列表
  @Action
  public SetHandler(appId: string) {
    this.SET_ISSUEHANDLER(appId)
  }
}

export const IssuesModule = getModule(Issues)
